// base_url: "https://altosconnectweb.in"
const config = {
    base_url: "https://multiuserindiaonline.infoxtechnologies.com/"
    // base_url: "https://altosconnectonline.com"

}
export default config